export default __webpack_public_path__ + "static/media/warning.d0b8f640.svg";